import axios from 'axios'
import { API_ENDPOINT } from '../../../../config'
import store from '../../../../redux/stores/store'
import { StringValidationRule } from "../../../../data/validation/rules"
import Validation from "../../../../data/validation/validation"

const getDefaultState = () => {
    return {
        processing: false,
        reason: "",
        errors: {},
        flag: {
            type: "",
            text: ""
        }
    }
}

const isValid = instance => {
    let validation = new Validation()
    let errors = instance.state.errors
    validation.addValidationRule(StringValidationRule, instance.state.reason, (error) => errors.reason = error, { min: { value: 1, error: "Invalid" }, max: { value: 1000, error: "Invalid" } })
    let validate = validation.validate()
    let stateUpdate = {
        errors: errors,
        flag: {
            type: validate ? "" : "error",
            text: validate ? "" : "Validation Failure"
        }
    }
    instance.setState({
        ...instance.state,
        ...stateUpdate
    })
    return validate
}

const rejectManuscript = (instance) => {
    instance.setState({
        ...instance.state,
        processing: true,
        flag: {
            type: "",
            text: ""
        }
    })
    axios({
        method: 'post',
        url: API_ENDPOINT + "/api/collaborators/reject",
        headers: {
            "Authorization": store.getState().auth.jwt
        },
        data: {
            collaboratorId: instance.props.collaboratorId,
            reason: instance.state.reason,
        }
    }).then(response => handleRejectManuscriptResponse(instance, response))
        .catch(error => {
            instance.setState({
                ...instance.state,
                processing: false,
                flag: {
                    type: "error",
                    text: "Unknown error"
                }
            })
        })
}

const handleRejectManuscriptResponse = (instance, response) => {
    if (response.status !== 200) {
        return
    }
    switch (response.data.status) {
        case 200:
            instance.props.history.push('/collaborators/' + instance.props.match.params.type)
            break
        default:
            instance.setState({
                ...instance.state,
                processing: false,
                flag: {
                    type: "error",
                    text: response.data.message
                }
            })
    }
}


const Worker = instance => {
    return {
        getDefaultState: getDefaultState,
        isValid: () => isValid(instance),
        rejectManuscript: () => rejectManuscript(instance)
    }
}

export default Worker